import { format, isAfter, isBefore, isSameDay } from 'date-fns'
import { useMemo } from 'react'
import ja from 'date-fns/locale/ja'

const useHeadline = (currentDate: Date): string => {
  const isToday = isSameDay(currentDate, new Date())
  const isPast = isBefore(currentDate, new Date())
  const isFuture = isAfter(currentDate, new Date())

  return useMemo(() => {
    switch (true) {
      case isToday:
        return '本日お渡しする注文'
      case isFuture:
        return `${format(currentDate, 'MM月dd日(E)', { locale: ja })}のお渡し`
      case isPast:
        return `${format(currentDate, 'MM月dd日(E)', { locale: ja })}のお渡し`
      default:
        return ''
    }
  }, [isToday, isPast, isFuture, currentDate])
}

export default useHeadline
